import ApiClient from './ApiClient';

export const fetchCustomTobPlans = ({ token, listOnly } = {}) => {
  return ApiClient.get(
    '/api/custom_tob_plans',
    {
      params: listOnly ? { list_only: true } : undefined,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      withCredentials: false,
    }
  );
};

export const fetchCustomTobPlan = ({ id, token }) => {
  return ApiClient.get(
    `/api/custom_tob_plans/${id}`,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      withCredentials: false,
    }
  );
};

export const createCustomTobPlan = ({ body, token }) => {
  return ApiClient.post(
    '/api/custom_tob_plans',
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      withCredentials: false,
    }
  );
};

export const updateCustomTobPlan = ({ id, body, token }) => {
  return ApiClient.put(
    `/api/custom_tob_plans/${id}`,
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      withCredentials: false,
    }
  );
};

export const deleteCustomTobPlan = ({ id, token }) => {
  return ApiClient.delete(
    `/api/custom_tob_plans/${id}`,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      withCredentials: false,
    }
  );
};

export const updateCustomTobPlanSortingOrder = ({ body, token }) => {
  return ApiClient.put(
    '/api/custom_tob_plans/update_sorting_order',
    body,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
      withCredentials: false,
    }
  );
};
